/**
 * KanbanDrag — HTML5 Drag API for the Issues Kanban board.
 * Each draggable issue card has phx-hook="KanbanDrag".
 * Each drop target column has data-kanban-column={status}.
 */
const KanbanDrag = {
  mounted() {
    this.el.setAttribute("draggable", "true")

    this.onDragStart = (e) => {
      e.dataTransfer.setData("application/seiva-issue", this.el.dataset.issueId)
      e.dataTransfer.effectAllowed = "move"
      this.el.classList.add("opacity-50", "scale-95")
    }

    this.onDragEnd = () => {
      this.el.classList.remove("opacity-50", "scale-95")
      document.querySelectorAll("[data-kanban-column]").forEach(col => {
        col.classList.remove("ring-2", "ring-[var(--accent-primary)]", "bg-[var(--accent-primary)]/5")
      })
    }

    this.el.addEventListener("dragstart", this.onDragStart)
    this.el.addEventListener("dragend", this.onDragEnd)

    // Set up column drop targets (only once per page)
    if (!window.__kanbanColumnsSetup) {
      window.__kanbanColumnsSetup = true
      this._setupColumns()
    }
  },

  _setupColumns() {
    const setupColumn = (col) => {
      col.addEventListener("dragover", (e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = "move"
        col.classList.add("ring-2", "ring-[var(--accent-primary)]", "bg-[var(--accent-primary)]/5")
      })

      col.addEventListener("dragleave", (e) => {
        if (!col.contains(e.relatedTarget)) {
          col.classList.remove("ring-2", "ring-[var(--accent-primary)]", "bg-[var(--accent-primary)]/5")
        }
      })

      col.addEventListener("drop", (e) => {
        e.preventDefault()
        col.classList.remove("ring-2", "ring-[var(--accent-primary)]", "bg-[var(--accent-primary)]/5")
        const issueId = e.dataTransfer.getData("application/seiva-issue")
        const toStatus = col.dataset.kanbanColumn
        if (issueId && toStatus) {
          // Push event to LiveView
          const hook = window.__liveSocket?.getHookCallbacks?.()
          // Use dispatchEvent to reach the LiveView root
          document.dispatchEvent(new CustomEvent("seiva:kanban_drop", {
            detail: { issue_id: issueId, to_status: toStatus }
          }))
        }
      })
    }

    // Set up existing columns
    document.querySelectorAll("[data-kanban-column]").forEach(setupColumn)

    // Observe new columns added dynamically
    const observer = new MutationObserver(() => {
      document.querySelectorAll("[data-kanban-column]:not([data-drag-init])").forEach(col => {
        col.setAttribute("data-drag-init", "true")
        setupColumn(col)
      })
    })
    observer.observe(document.body, { childList: true, subtree: true })
  },

  destroyed() {
    this.el.removeEventListener("dragstart", this.onDragStart)
    this.el.removeEventListener("dragend", this.onDragEnd)
  }
}

export default KanbanDrag
